const itemTypeDisplay = {
  'Multiple Choice': {
    passage: false,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true,
  },
  'Multiple Choice Passage': {
    passage: true,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true,
  },
  'Multiple Choice Passage Line Nums': {
    passage: true,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true,
  },
  'Passage': {
    passage: true,
  },
  'Content': {
    content: true,
    teacherGuidance: true,
    instructions: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
  },
  'Directions': {
    instructions: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true,
  },
  'Infographic': {
    imageLink: true,
    imageDescription: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true,
  },
  'Infographic Two Column': {
    imageLink: true,
    imageDescription: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true,
  },
  'Slide': {
    imageLink: true,
    imageDescription: true,
    content: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true,
  }
}

export default itemTypeDisplay


// WEBPACK FOOTER //
// ./src/helpers/itemTypeDisplay.js